import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, createBlock as _createBlock, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7302b772"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "noodleprint" }
const _hoisted_2 = { style: {"display":"flex","flex-direction":"column","justify-content":"flex-start"} }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "打印面单纸张:", -1))
const _hoisted_4 = { style: {"margin-top":"20px"} }
const _hoisted_5 = { style: {"margin-top":"30px"} }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "打印尺寸:", -1))
const _hoisted_7 = { style: {"margin-top":"20px"} }
const _hoisted_8 = { id: "printImg" }
const _hoisted_9 = ["src"]
const _hoisted_10 = ["id"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_radio = _resolveComponent("a-radio")!
  const _component_a_radio_group = _resolveComponent("a-radio-group")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_space = _resolveComponent("a-space")!
  const _directive_print = _resolveDirective("print")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_a_col, {
          span: 10,
          style: {"display":"flex","flex-direction":"column","justify-content":"flex-start","align-items":"center"}
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", null, [
                _hoisted_3,
                _createElementVNode("div", _hoisted_4, [
                  _createVNode(_component_a_radio_group, {
                    value: _ctx.modelRef.checkedV,
                    "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.modelRef.checkedV) = $event))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_radio, { value: 1 }, {
                        default: _withCtx(() => [
                          _createTextVNode("热敏纸")
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_radio, { value: 2 }, {
                        default: _withCtx(() => [
                          _createTextVNode("A4纸")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["value"])
                ])
              ]),
              _createElementVNode("div", _hoisted_5, [
                _hoisted_6,
                _createElementVNode("div", _hoisted_7, [
                  _createVNode(_component_a_radio, {
                    value: _ctx.modelRef.a4V,
                    "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.modelRef.a4V) = $event)),
                    checked: ""
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("10cm*10cm")
                    ]),
                    _: 1
                  }, 8, ["value"])
                ])
              ])
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_a_col, { span: 12 }, {
          default: _withCtx(() => [
            _createElementVNode("div", {
              class: _normalizeClass(!_ctx.tSty ? '' : 'imgBox')
            }, [
              _createElementVNode("div", _hoisted_8, [
                (!_ctx.tSty)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      src: _ctx.imgSrc,
                      class: "img",
                      alt: ""
                    }, null, 8, _hoisted_9))
                  : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.pageNum, (item) => {
                      return (_openBlock(), _createElementBlock("canvas", {
                        key: item,
                        id: `pdf-canvas-${item}`,
                        class: "pdf-page",
                        style: {"width":"auto"}
                      }, null, 8, _hoisted_10))
                    }), 128))
              ])
            ], 2)
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_a_row, {
      justify: "center",
      style: {"margin-top":"30px"}
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_space, null, {
          default: _withCtx(() => [
            _withDirectives((_openBlock(), _createBlock(_component_a_button, { type: "primary" }, {
              default: _withCtx(() => [
                _createTextVNode("确认打印")
              ]),
              _: 1
            })), [
              [_directive_print, _ctx.data.printObj]
            ]),
            _createVNode(_component_a_button, { onClick: _ctx.handleCtrl }, {
              default: _withCtx(() => [
                _createTextVNode("取消")
              ]),
              _: 1
            }, 8, ["onClick"])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}